import { render, staticRenderFns } from "./InvalidInputs.vue?vue&type=template&id=33dcc608"
import script from "./InvalidInputs.vue?vue&type=script&lang=js"
export * from "./InvalidInputs.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports